/**
 * Plays a soft `swoosh` on every successful route transition. Layers under
 * the per-link `tick` press sound so a click reads as press + travel.
 * No-op until the user opts in via MSoundToggle.
 */
export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const { play } = useSound()

  let firstNavSkipped = false
  router.afterEach((to, from) => {
    // Skip the initial hydration "navigation" — there's no actual transition.
    if (!firstNavSkipped) {
      firstNavSkipped = true
      return
    }
    if (to.fullPath === from.fullPath)
      return
    play('swoosh', { gain: 0.75, throttle: 250 })
  })

  // Reference nuxtApp to silence unused-arg in strict configs.
  void nuxtApp
})
